import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { DesignContestDto } from "../../../autogen/bff-api";
import { DesignContestTermsSection } from "../../sourcing-events/portal/view-single/EventDesignContestSection";

export const BuyerDesignContestSection = ({ contest }: { contest: DesignContestDto }) => {
  const { t } = useTranslation();
  const jury = contest.jury ?? [];
  return (
    <DesignContestTermsSection
      contest={{ ...contest, juryCriteria: contest.juryCriteria ?? [], prizes: contest.prizes ?? [], jury }}
      notice={t(
        "The participants are told to keep their entries anonymous, and the jury judges them without knowing who is behind each until the decision is registered.",
      )}
      memberDetail={(index) => {
        const member = jury[index];
        const notes = [
          member?.personId ? t("confirms in SourceMagnet") : t("confirms outside SourceMagnet"),
          member?.independenceConfirmed ? t("independence confirmed") : t("independence not confirmed"),
        ];
        return (
          <Text as="span" color="smMuted">
            {` · ${notes.join(" · ")}`}
          </Text>
        );
      }}
    />
  );
};
